(() => {
  "use strict";

  const BASE_WIDTH = 1154;
  const BASE_HEIGHT = 281;
  const TRACE_MS = 6500;
  const TRACE_END = 0.7;
  const FLICKER_END = 0.77;
  const PURPLE = [186, 76, 255];
  const YELLOW = [255, 212, 61];
  const WHITE = [255, 255, 255];
  const TRACE_PATHS = [{"name":"icon top","paths":[{"points":[[129.0,53.5],[163.0,100.5],[205.5,124.0],[205.5,74.0],[201.0,69.5],[193.0,66.5],[93.0,-0.5],[93.5,4.0],[101.5,16.0]],"length":378.17,"area":4216.5,"box":[92.5,-0.5,205.5,124.5]}]},{"name":"icon upper","paths":[{"points":[[66.0,69.5],[30.5,44.0],[127.0,66.5],[133.5,73.0],[147.5,99.0],[123.0,103.5],[114.0,103.5]],"length":291.32,"area":2630.5,"box":[30.5,43.5,147.5,103.5]}]},{"name":"icon middle","paths":[{"points":[[186.0,151.5],[204.0,141.5],[205.5,137.0],[151.0,107.5],[-0.5,139.0],[150.0,171.5]],"length":466.78,"area":6711.5,"box":[-0.5,107.5,205.5,171.5]}]},{"name":"icon lower","paths":[{"points":[[69.0,206.5],[29.0,233.5],[27.5,236.0],[31.0,236.5],[128.0,212.5],[146.5,179.0],[115.0,174.5]],"length":298.74,"area":2756.5,"box":[27.5,174.5,146.5,236.5]}]},{"name":"icon bottom","paths":[{"points":[[191.5,162.0],[160.5,181.0],[133.5,220.0],[111.5,248.0],[109.5,254.0],[91.5,279.0],[92.0,280.5],[145.0,247.5],[162.0,234.5],[168.0,232.5],[171.0,228.5],[196.0,211.5],[202.0,210.5],[205.5,207.0],[205.5,154.0]],"length":384.76,"area":4428.5,"box":[91.5,153.5,205.5,280.5]}]},{"name":"H","paths":[{"points":[[248.5,215.0],[248.5,158.0],[304.0,157.5],[304.5,227.0],[345.5,227.0],[345.5,170.0],[347.5,169.0],[347.0,50.5],[304.5,51.0],[304.0,121.5],[249.0,121.5],[248.5,51.0],[208.5,51.0],[208.5,227.0],[248.0,227.5]],"length":909.9,"area":16590.5,"box":[208.5,50.5,347.5,227.5]}]},{"name":"U","paths":[{"points":[[344.5,82.0],[345.0,50.5],[389.5,51.0],[390.5,172.0],[394.5,181.0],[400.0,186.5],[410.0,190.5],[424.0,190.5],[433.0,187.5],[438.5,183.0],[444.5,168.0],[445.5,51.0],[488.5,51.0],[488.5,174.0],[485.5,175.0],[483.5,190.0],[477.5,204.0],[467.0,216.5],[447.0,227.5],[388.0,227.5],[382.0,225.5],[365.0,214.5],[355.5,202.0],[349.5,185.0],[348.5,170.0],[346.0,169.5],[344.5,227.0]],"length":983.52,"area":16500.5,"box":[344.5,50.5,488.5,227.5]}]},{"name":"RREY","paths":[{"points":[[808.0,87.5],[862.0,87.5],[864.5,90.0],[903.5,149.0],[904.0,227.5],[944.5,227.0],[944.5,149.0],[992.0,77.5],[1002.0,61.0],[1009.0,50.5],[961.0,50.5],[925.0,105.5],[922.5,105.0],[887.0,50.5],[755.0,50.5],[754.5,207.0],[751.0,207.5],[708.5,157.0],[710.0,153.5],[721.0,148.5],[731.5,139.0],[740.5,122.0],[742.5,113.0],[741.5,89.0],[739.5,82.0],[731.5,69.0],[720.0,59.5],[710.0,54.5],[698.0,51.5],[622.0,50.5],[621.5,207.0],[618.0,207.5],[576.5,158.0],[578.0,153.5],[587.0,149.5],[599.5,138.0],[607.5,123.0],[609.5,115.0],[609.5,93.0],[606.5,82.0],[600.5,71.0],[584.0,57.5],[565.0,51.5],[486.0,50.5],[485.5,174.0],[488.5,175.0],[488.5,227.0],[529.5,227.0],[529.5,163.0],[532.0,162.5],[582.0,227.5],[662.0,227.5],[662.5,163.0],[665.0,162.5],[715.0,227.5],[855.0,227.5],[855.0,191.5],[795.5,191.0],[796.0,157.5],[853.5,157.0],[853.0,121.5],[795.5,121.0],[795.5,88.0]],"length":2935.98,"area":63278.5,"box":[485.5,50.5,1011.5,227.5]},{"points":[[529.5,94.0],[530.0,129.5],[552.0,127.5],[562.5,121.0],[566.5,112.0],[566.5,101.0],[564.5,95.0],[559.0,88.5],[548.0,84.5],[530.0,83.5]],"length":150.77,"area":1465.5,"box":[529.5,83.5,566.5,129.5]},{"points":[[662.5,101.0],[663.0,83.5],[681.0,84.5],[688.0,86.5],[694.5,91.0],[698.5,98.0],[698.5,115.0],[694.5,122.0],[688.0,126.5],[681.0,128.5],[663.0,129.5]],"length":150.77,"area":1457.5,"box":[662.5,83.5,699.5,129.5]}]},{"name":"S","paths":[{"points":[[999.0,70.5],[990.5,85.0],[988.5,108.0],[995.0,129.0],[1012.0,146.0],[1056.0,168.5],[1060.5,174.0],[1061.5,183.0],[1059.5,188.0],[1053.0,193.5],[1035.0,196.5],[1018.0,191.5],[993.0,176.5],[972.5,210.0],[983.0,218.5],[1003.0,228.5],[1033.0,234.5],[1046.0,234.5],[1065.0,231.5],[1088.0,220.5],[1098.5,209.0],[1104.5,195.0],[1106.5,185.0],[1106.5,171.0],[1103.5,161.0],[1095.5,149.0],[1081.0,136.5],[1035.0,113.5],[1028.5,106.0],[1028.5,100.0],[1030.5,96.0],[1039.0,89.5],[1056.0,88.5],[1072.0,93.5],[1085.0,100.5],[1101.5,68.0],[1096.0,63.5],[1078.0,55.5],[1062.0,51.5],[1041.0,50.5],[1019.0,56.5]],"length":977.28,"area":15075.5,"box":[969.5,50.5,1106.5,234.5]}]},{"name":"dot","paths":[{"points":[[1127.0,184.5],[1135.0,184.5],[1142.0,187.5],[1153.5,200.0],[1153.5,219.0],[1143.0,230.5],[1132.0,234.5],[1121.0,233.5],[1115.0,230.5],[1107.5,223.0],[1104.5,216.0],[1104.5,203.0],[1109.5,193.0],[1120.0,185.5]],"length":166.37,"area":1975.5,"box":[1104.5,184.5,1153.5,234.5]}]}];

  function easeInOutSine(t) {
    return -(Math.cos(Math.PI * t) - 1) / 2;
  }

  function rgba(color, alpha) {
    return `rgba(${color[0]},${color[1]},${color[2]},${alpha})`;
  }

  function mix(a, b, amount) {
    return [
      Math.round(a[0] + (b[0] - a[0]) * amount),
      Math.round(a[1] + (b[1] - a[1]) * amount),
      Math.round(a[2] + (b[2] - a[2]) * amount)
    ];
  }

  function distance(a, b) {
    return Math.hypot(b[0] - a[0], b[1] - a[1]);
  }

  function preparePath(path) {
    const points = path.points;
    const closed = path.closed === false ? points : points.concat([points[0]]);
    const lengths = [0];
    let total = 0;

    for (let i = 1; i < closed.length; i += 1) {
      total += distance(closed[i - 1], closed[i]);
      lengths.push(total);
    }

    return { points: closed, lengths, total };
  }

  const preparedPieces = TRACE_PATHS.map((piece) => ({
    name: piece.name,
    paths: piece.paths.map(preparePath)
  }));

  function pointAt(path, amount) {
    const target = Math.max(0, Math.min(path.total, path.total * amount));

    for (let i = 1; i < path.lengths.length; i += 1) {
      if (path.lengths[i] < target) continue;

      const prevLen = path.lengths[i - 1];
      const segLen = path.lengths[i] - prevLen || 1;
      const t = (target - prevLen) / segLen;
      const a = path.points[i - 1];
      const b = path.points[i];

      return [
        a[0] + (b[0] - a[0]) * t,
        a[1] + (b[1] - a[1]) * t
      ];
    }

    return path.points[path.points.length - 1];
  }

  function tracePathOn(targetCtx, path, amount) {
    const target = Math.max(0, Math.min(path.total, path.total * amount));
    if (target <= 0 || path.points.length < 2) return;

    targetCtx.beginPath();
    targetCtx.moveTo(path.points[0][0], path.points[0][1]);

    for (let i = 1; i < path.points.length; i += 1) {
      const currentLen = path.lengths[i];
      const prevLen = path.lengths[i - 1];

      if (currentLen <= target) {
        targetCtx.lineTo(path.points[i][0], path.points[i][1]);
        continue;
      }

      const segLen = currentLen - prevLen || 1;
      const t = (target - prevLen) / segLen;
      const a = path.points[i - 1];
      const b = path.points[i];
      targetCtx.lineTo(a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t);
      break;
    }
  }

  function powerChange(phase) {
    const t = (phase - TRACE_END) / (FLICKER_END - TRACE_END);

    if (t < 0.08) return { color: PURPLE, opacity: 0.12 };
    if (t < 0.2) return { color: YELLOW, opacity: 1.18 };
    if (t < 0.3) return { color: YELLOW, opacity: 0.06 };
    if (t < 0.45) return { color: YELLOW, opacity: 1.08 };
    if (t < 0.54) return { color: YELLOW, opacity: 0.24 };
    if (t < 0.7) return { color: YELLOW, opacity: 1.2 };

    return { color: YELLOW, opacity: 1 };
  }

  function createRenderer(canvas) {
    const rect = canvas.getBoundingClientRect();
    const displayWidth = Math.max(1, rect.width || BASE_WIDTH);
    const displayHeight = Math.max(1, rect.height || BASE_HEIGHT);
    const dpr = Math.max(1, window.devicePixelRatio || 1);
    const renderWidth = Math.round(displayWidth * dpr);
    const renderHeight = Math.round(displayHeight * dpr);
    const fitScale = Math.min(renderWidth / BASE_WIDTH, renderHeight / BASE_HEIGHT);
    const fitX = (renderWidth - BASE_WIDTH * fitScale) / 2;
    const fitY = (renderHeight - BASE_HEIGHT * fitScale) / 2;

    canvas.width = renderWidth;
    canvas.height = renderHeight;

    const ctx = canvas.getContext("2d");
    if (!ctx) return null;

    const maskCanvas = document.createElement("canvas");
    maskCanvas.width = renderWidth;
    maskCanvas.height = renderHeight;

    const maskCtx = maskCanvas.getContext("2d");
    if (!maskCtx) return null;

    function drawStrokes(progress, color, opacity, heads) {
      const core = mix(color, WHITE, 0.5);
      const passes = [
        { width: 16, blur: 14, alpha: 0.22, blend: "lighter" },
        { width: 9, blur: 7, alpha: 0.32, blend: "lighter" },
        { width: 5.3, blur: 2, alpha: 0.54, blend: "source-over" },
        { width: 3.2, blur: 0, alpha: 0.9, blend: "source-over", color },
        { width: 1.25, blur: 0, alpha: 0.96, blend: "source-over", color: core }
      ];

      for (const pass of passes) {
        maskCtx.clearRect(0, 0, renderWidth, renderHeight);
        maskCtx.save();
        maskCtx.translate(fitX, fitY);
        maskCtx.scale(fitScale, fitScale);
        maskCtx.globalCompositeOperation = "source-over";
        maskCtx.lineCap = "round";
        maskCtx.lineJoin = "round";
        maskCtx.lineWidth = pass.width;
        maskCtx.strokeStyle = rgba(pass.color || color, pass.alpha * opacity);

        for (const piece of preparedPieces) {
          for (const path of piece.paths) {
            tracePathOn(maskCtx, path, progress);
            maskCtx.stroke();
          }
        }

        maskCtx.restore();

        ctx.save();
        ctx.globalCompositeOperation = pass.blend;
        ctx.globalAlpha = 1;
        ctx.filter = pass.blur ? `blur(${pass.blur * fitScale}px)` : "none";
        ctx.drawImage(maskCanvas, 0, 0);
        ctx.restore();
      }

      if (!heads) return;

      ctx.save();
      ctx.globalCompositeOperation = "lighter";
      ctx.translate(fitX, fitY);
      ctx.scale(fitScale, fitScale);

      for (const piece of preparedPieces) {
        const headPath = piece.paths[0];
        if (!headPath) continue;

        const [x, y] = pointAt(headPath, progress);
        const glow = ctx.createRadialGradient(x, y, 0, x, y, 15);
        glow.addColorStop(0, rgba(WHITE, opacity));
        glow.addColorStop(0.24, rgba(color, 0.88 * opacity));
        glow.addColorStop(1, rgba(color, 0));
        ctx.fillStyle = glow;
        ctx.beginPath();
        ctx.arc(x, y, 15, 0, Math.PI * 2);
        ctx.fill();
      }

      ctx.restore();
    }

    return {
      clear() {
        ctx.clearRect(0, 0, renderWidth, renderHeight);
      },
      render(phase) {
        ctx.clearRect(0, 0, renderWidth, renderHeight);

        if (phase < TRACE_END) {
          drawStrokes(easeInOutSine(phase / TRACE_END), PURPLE, 1, true);
          return;
        }

        if (phase < FLICKER_END) {
          const state = powerChange(phase);
          drawStrokes(1, state.color, state.opacity, false);
          return;
        }

        const settle = (phase - FLICKER_END) / (1 - FLICKER_END);
        const pulse = 0.94 + Math.sin(settle * Math.PI) * 0.06;
        drawStrokes(1, YELLOW, pulse, false);
      }
    };
  }

  function complete(shell, renderer) {
    shell.classList.add("is-neon-complete");

    window.setTimeout(() => {
      if (renderer) renderer.clear();
    }, 320);
  }

  let hasAnimatedBatch = false;
  const SESSION_KEY = "hurreysNeonLogoAnimated";

  function isReloadNavigation() {
    try {
      const entry = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
      if (entry && entry.type === "reload") return true;
      return performance.navigation && performance.navigation.type === 1;
    } catch (error) {
      return false;
    }
  }

  function hasSessionAnimation() {
    try {
      return window.sessionStorage && window.sessionStorage.getItem(SESSION_KEY) === "1";
    } catch (error) {
      return false;
    }
  }

  function markSessionAnimation() {
    try {
      if (window.sessionStorage) window.sessionStorage.setItem(SESSION_KEY, "1");
    } catch (error) {}
  }

  function runLogo(shell, shouldAnimate) {
    if (!shell || shell.dataset.hpNeonInit === "1") return;
    shell.dataset.hpNeonInit = "1";

    const canvas = shell.querySelector(".hp-neon-logo__canvas");
    const isSmallScreen = window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
    const prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const savesData = !!(navigator.connection && navigator.connection.saveData);
    if (!shouldAnimate || !canvas || !window.requestAnimationFrame || isSmallScreen || prefersReducedMotion || savesData) {
      shell.classList.add("is-neon-complete");
      return;
    }

    const renderer = createRenderer(canvas);
    if (!renderer) {
      shell.classList.add("is-neon-complete");
      return;
    }

    shell.classList.add("is-neon-ready");

    let startTime = null;

    function frame(now) {
      if (startTime === null) startTime = now;

      const phase = Math.min((now - startTime) / TRACE_MS, 1);
      renderer.render(phase);

      if (phase < 1) {
        window.requestAnimationFrame(frame);
        return;
      }

      complete(shell, renderer);
    }

    window.requestAnimationFrame(frame);
  }

  function initAll() {
    const shells = Array.from(document.querySelectorAll("[data-hp-neon-logo]"))
      .filter((shell) => shell.dataset.hpNeonInit !== "1");

    if (!shells.length) return;

    const allowReplay = isReloadNavigation();
    const shouldAnimate = !hasAnimatedBatch && (allowReplay || !hasSessionAnimation());
    if (shouldAnimate) hasAnimatedBatch = true;
    if (shouldAnimate) markSessionAnimation();

    shells.forEach((shell) => runLogo(shell, shouldAnimate));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  if ("MutationObserver" in window) {
    const observer = new MutationObserver(initAll);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
